import styled from '@emotion/styled';
import {mq} from '@styles/helpers';
import {Devices} from '@styles/tokens';

export const Wrapper = styled.div<{start?:boolean, background?:string}>`
    position: fixed;
    top:0;
    left:0;
    width:100vw;
    height:100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;

    transform: scale(${props => props.start?"1":"0"});
    opacity: ${props => props.start?"1":"0"};
`; 

export const Container = styled.div`
    max-width: 500px;
    width:100%;
    min-width: 300px;
    display: flex;
    flex-direction: column;
    background:#fff;
    box-shadow: 0 0 4px 2px rgba(0,0,0,0.3);
    border-radius: 10px;
    overflow:hidden;
    margin-top: - var("--regi-nav-height");

    ${mq(Devices.mobile)} {
        margin:0 10px;
    }
`; 

export const PreviewTop = styled.div`
    padding:16px;
    display: flex;
    align-items: center;
    background:#EBEBEB;

    span{
        font-size: 20px;
        font-weight:  700;        
    }    
`; 

export const CloseButton = styled.button`
    margin-left: auto;
    background:#2A848E;
    border-radius:50%;
    height:34px;
    width:34px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;

    svg{
        height:50%;
        path{
            fill:#fff;
        }
    }

    :hover{
        background:#2a848ecc;
    }
`; 

export const BadgeRow = styled.div<{paddingTop?:number}>`
    min-height:50px;
    width:100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: ${props => props.paddingTop?props.paddingTop + "px":"0"};
  text-align: center;
`; 

export const ScreenTitle = styled.span`
    font-size: 20px;
    color:#FA505E;
    font-weight: 700;
    margin-top: auto;
`; 

export const BadgeTitle = styled.span`
    font-size: 42px;
    color:#000;
    font-weight: 700;
`; 

export const BadgeDescription = styled.div`
    font-size: 20px;
    color:#171717;
    max-width: 550px;
    text-align: center;
    padding:0 20px;
`; 

export const BadgeCompletion = styled.div`
    font-size: 20px;
    color:#171717;
    font-weight: 700;
    max-width: 550px;
    text-align: center;
    padding-bottom:20px;
`; 